import { GridColDef } from "@mui/x-data-grid-premium";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Link } from "react-router-dom";
import MotherFallRiskAssessment from "../create";
import MotherFallExampleRows from "../model";
import BaseMedCardList from "src/components/shared-components/medcard/BaseMedCardList";
//IDOGAN;446144;04032025
const columns: GridColDef[] = [
  {
    field: "update",
    headerName: "Güncelle",
    width: 150,
    renderCell(params) {
      return (
        <Link to={`edit/${params.row.id}`}>
          <EditIcon color="info" />
        </Link>
      );
    },
  },
  { field: "date", headerName: "Tarih", flex: 1 },
  { field: "field1", headerName: "Alan 1", flex: 1 },
  { field: "field2", headerName: "Alan 2", flex: 1 },
  { field: "field3", headerName: "Alan 3", flex: 1 },
  { field: "field4", headerName: "Alan 4", flex: 1 },
  { field: "field5", headerName: "Alan 5", flex: 1 },
  {
    field: "delete",
    headerName: "Sil",
    flex: 1,
    renderCell: (params) => (
      <IconButton onClick={() => console.log(params.row.id)}>
        <DeleteIcon color="error" />
      </IconButton>
    ),
  },
];

function MotherFallRiskAssessmentList() {
  return (
    <BaseMedCardList
      title="Anne Düşme Risk Ölçeği"
      columns={columns}
      rows={MotherFallExampleRows}
      CreateComponent={MotherFallRiskAssessment}
      pageSize={10}
    />
  );
}

export default MotherFallRiskAssessmentList;
